import script from "./DoctorList.vue?vue&type=script&setup=true&lang=ts"
export * from "./DoctorList.vue?vue&type=script&setup=true&lang=ts"

import "./DoctorList.vue?vue&type=style&index=0&id=f4109806&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f4109806"]])

export default __exports__